import { TestVariableBlockCombinedProps } from './types';

const usePresenter = (props: TestVariableBlockCombinedProps): TestVariableBlockCombinedProps => {
  return props;
};

export default usePresenter;
